import React, { useEffect, useMemo, useState } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { getGroupByUserList } from '../../../axios/User/UserApi';
import { toast } from 'react-toastify';
import { Box } from '@mui/system';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import { StyledDataGrid } from '../../../components/StyledComponents';
import DeviceApi from '../../../axios/Device/DeviceApi';
import { useRefresh } from '../../../context/RefreshContext';
import CustomPagination from '../CustomPagination';
import { useAuth } from '../../../context/AuthContext';

const DeviceManagement = (props) => {
    const { userId } = props;
    const { t, i18n } = useTranslation();
    const [show, hide] = useLoading();
    const [rowData, setRowData] = useState([]);
    const [rowCount, setRowCount] = useState(0)
    const [filteredRowData, setFilteredRowData] = useState([]);
    const [filteredRowCount, setFilteredRowCount] = useState(0);
    const { getDeviceList } = DeviceApi()
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [totalPages, setTotalPages] = useState(1);
    const { refreshData, handleRefreshData } = useRefresh();
    const { getDeviceListDetailUser } = DeviceApi()
    const { profile, isAdmin } = useAuth()

    const fetchData = async () => {
        show();
        try {
            const response = await getDeviceListDetailUser(
                {
                    userId: isAdmin ? userId : profile.userId,
                },
                localStorage.getItem("i18nextLngId")
            );

            if (
                response.data.message === "Successful" ||
                response.data.message === "Thành công"
            ) {
                const dataWithId = response.data.data;
                setRowData(dataWithId || []);
            }

        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    // ✅ case bạn cần
                    setRowData([]);
                } else if (error.response.status !== 401) {
                    toast.error('Error fetching data');
                }
            } else {
                // network error
                // setRowData([]); // optional nếu muốn clear luôn
            }

            console.error('Error fetching data:', error);
        } finally {
            hide();
        }
    };

    useEffect(() => {
        show()
        const timeoutId = setTimeout(() => {
            fetchData();
            hide()
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [page, pageSize, refreshData]);

    const columnData = useMemo(
        () => [
            {
                field: "deviceName",
                headerName: t("common.device-name"),
                flex: 1.2,
            },

            {
                field: "deviceOS",
                headerName: t("common.os-name"),
                flex: 1,
            },
        ],
        [t, i18n.language]
    );

    const handleRowsPerPageChange = (newPageSize) => {
        // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
        const size =
            typeof newPageSize === "number"
                ? newPageSize
                : parseInt(newPageSize.target.value, 10);

        setPage((prevPage) => {
            // index của record đầu tiên đang xem
            const firstRowIndex = prevPage * pageSize;

            // page mới sao cho vẫn chứa record đó
            const newPage = Math.floor(firstRowIndex / size);

            // phòng trường hợp vượt quá số trang
            const maxPage = Math.max(
                0,
                Math.ceil(rowCount / size) - 1
            );

            return Math.min(newPage, maxPage);
        });

        setPageSize(size);
    };

    return (
        <Box className="flex flex-col gap-4">
            <StyledDataGrid
                rows={rowData}
                // rowCount={rowCount}
                columns={columnData}
                getRowId={(row) => row.id}
                hideFooter
                disableRowSelectionOnClick
                columnHeaderHeight={44}
                rowHeight={48}
                slots={{
                    // pagination: CustomPagination,
                    noRowsOverlay: NoRowOverlay,
                    columnsPanel: CustomColumnsPanel,
                }}
                slotProps={{
                    noRowsOverlay: {
                        title: t("common.no-devices-registed"),
                    },
                }}
                sx={{
                    height: 'auto',

                    ...(rowData.length === 0 && {
                        "& .MuiDataGrid-virtualScroller": {
                            overflow: "hidden !important",
                        },
                    }),

                    "@media (max-width: 1919px)": {
                        height: 'auto',
                    },

                    ".MuiDataGrid-main": {
                        height: "70.5vh",
                    },

                    "& .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
                    {
                        display: "none !important",
                    },

                    "& .MuiDataGrid-scrollbarFiller": {
                        display: "none !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        paddingRight: 0,
                    },
                    "& .MuiDataGrid-topContainer": {
                        paddingRight: 0,
                    },

                    "&": {
                        "--DataGrid-scrollbarSize": "0px",
                    },

                    "& .MuiDataGrid-virtualScroller": {
                        scrollbarWidth: "none",
                    },
                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                        width: 0,
                        height: 0,
                    },
                    "&:hover .MuiDataGrid-virtualScroller, &:focus-within .MuiDataGrid-virtualScroller":
                    {
                        scrollbarWidth: "thin",
                    },
                    "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar, &:focus-within .MuiDataGrid-virtualScroller::-webkit-scrollbar":
                    {
                        width: 10,
                        height: 10,
                    },

                    '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
                        display: "none !important",
                    },

                    "& input[type=number]::-webkit-inner-spin-button, \
             & input[type=number]::-webkit-outer-spin-button": {
                        WebkitAppearance: "none",
                        margin: 0,
                    },

                    "& input[type=number]": {
                        textAlign: "center",
                        MozAppearance: "textfield",
                        WebkitAppearance: "none",
                        padding: "5px !important",
                        height: "100%",
                        pointerEvents: "none",
                        caretColor: "transparent",
                        userSelect: "none",
                        paddingTop: "8px !important",
                        paddingBottom: "8px !important"
                    },

                    // "& .MuiDataGrid-overlayWrapper": {
                    //     height: "100%",
                    // },

                    // "& .MuiDataGrid-overlay": {
                    //     height: "100%",
                    //     display: "flex",
                    //     alignItems: "center",
                    //     justifyContent: "center",
                    // },
                }}
            />
        </Box>
    )
}

export default DeviceManagement